import * as r from "react/jsx-runtime";
import { wrap } from "./jsx";

export type { JSX } from "./jsx";

export const jsx = wrap(r.jsx);
export const jsxs = wrap(r.jsxs);
export const Fragment = r.Fragment;
